<script setup>
  import { defineProps } from 'vue';
  import MainButton from '@/Components/MainButton.vue';
  import SecondaryButton from '@/Components/SecondaryButton.vue';

  // Define props for dynamic content
  const props = defineProps({
    image: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    buttonText1: {
      type: String,
      default: 'Join Spicycollab'
    },
    buttonText2: {
      type: String,
      default: 'Explore More'
    },
    buttonLink1: {
      type: String,
      default: '/register'
    },
    actionButtons: {
      type: Boolean,
      default: false
    }
  });
</script>

<template>
  <div>
    <!-- Hero Image -->
    <div class="relative h-[500px] md:h-[600px] lg:h-[700px]">
      <img
        :src="props.image"
        alt="Hero Image"
        class="absolute inset-0 h-full w-full overflow-hidden rounded-b-2xl object-cover bg-blend-darken shadow-xl"
      />
      <div class="hero-image-overlay"></div>

      <!-- Text Section -->
      <section
        class="absolute left-4 top-20 z-20 text-white lg:left-28 lg:top-36"
      >
        <div class="max-w-6xl">
          <div
            class="flex flex-col font-title text-3xl md:text-4xl lg:gap-4 lg:text-6xl"
          >
            <p>{{ props.title }}</p>
            <p class="font-semibold">{{ props.subtitle }}</p>
          </div>
          <div class="mt-4">
            <p class="w-1/2 text-sm md:text-lg">
              {{ props.description }}
            </p>
          </div>
          <div class="mt-4 flex flex-row gap-4" v-if="actionButtons">
            <MainButton>
              <a
                :href="props.buttonLink1"
                class="!text-white hover:!text-white"
              >
                {{ props.buttonText1 }}
              </a>
            </MainButton>
            <SecondaryButton class="border-white text-white">
              {{ props.buttonText2 }}
            </SecondaryButton>
          </div>
        </div>
      </section>
    </div>

    <!-- Bottom Content -->
    <div class="bottom-content -mt-12 h-20 bg-primary"></div>
  </div>
</template>

<style scoped>
  .bottom-content {
    border-bottom-left-radius: 2rem;
    border-bottom-right-radius: 2rem;
  }

  .hero-image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(29, 2, 43, 0.5) !important;
    border-bottom-left-radius: 2rem;
    border-bottom-right-radius: 1rem;
    z-index: 10; /* Ensure overlay is below the text section */
  }

  .hero-image {
    position: relative;
    display: flex;
    align-items: center;
  }

  .hero-image img {
    position: relative;
    object-fit: cover;
  }
</style>
